<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full md:bg-white md:rounded-lg md:shadow-l md:p-8 space-y-6">

    <div class="flex items-center justify-between mb-8">
      <h1 class="text-xl font-bold">Ordini di Servizio</h1>
    </div>

    <app-search-panel [searchFields]="searchPanelConfig" (searchParamChange)="onSearchParamChange($event)"></app-search-panel>

    <div class="shadow-lg overflow-auto w-full">
      <div class="grid w-full table-grid gap-x-8 gap-y-6 px-6 py-3">
        <div class="table-header-row" (click)="setOrder('id')">ID <span *ngIf="currentSort.field === 'id'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span> </div>
        <div class="table-header-row" (click)="setOrder('document_id_subject')">Nome  <span *ngIf="currentSort.field === 'document_id_subject'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('preview_number')">Codice  <span *ngIf="currentSort.field === 'preview_number'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('state')">Stato  <span *ngIf="currentSort.field === 'state'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('registration_date')">Data  <span *ngIf="currentSort.field === 'registration_date'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>

      @for (procedure of pagedData; track procedure.id) {
        <div class="contents hover:bg-gray-100 odd:bg-white even:bg-gray-50 cursor-pointer whitespace-nowrap text-sm text-gray-900" (click)="onRowClicked(procedure.id)">
          <div>{{ procedure.id }}</div>
          <div>{{ procedure.label | truncate }}</div>
          <div>{{ procedure.code }}</div>
          <div>{{ procedure.state.label }}</div>
          <div>{{ procedure.date | date: 'dd/MM/yyyy HH:mm:ss' }}
          </div>
        </div>
      }
      </div>
    </div>

    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pagination>

    <div class="flex items-center justify-end mb-8">
      <button (click)="fetchProcedures({})" class="button">
        Aggiorna Elenco
      </button>
    </div>

  </div>
</div>
